module.exports = "/_next/static/images/MobileFistProcess-4e8e60be06722a0ee75c00e841ed3cec.png";